import Api from "../../../library/api";
import { showError } from "../../snackbars/snackbars-actions";

export const REQUEST_USERS_LIST = "REQUEST_USERS_LIST";
export const USERS_LIST_FAILED = "USERS_LIST_FAILED";
export const USERS_LIST_SUCCESS = "USERS_LIST_SUCCESS";

export function requestUsersList(payload) {
  return dispatch => {
    dispatch({ type: REQUEST_USERS_LIST });

    Api.post("p/accounts", payload).then(resp => {
      if (resp.err) {
        dispatch({ type: USERS_LIST_FAILED });
        dispatch(showError(resp.err));
        return;
      }

      dispatch({
        type: USERS_LIST_SUCCESS,
        data: resp
      });
    });
  };
}



// WEBPACK FOOTER //
// ./src/components/users-and-permissions/users-listing/users-listing-actions.js